/** Statsig feature gate names (must match Statsig console). */
export const DIGITAL_INVOICE_TAX = 'digital_invoice_tax';
